import Element, { IElementLayout } from '../../Prototype/UI/Element';
import UITextComponent from '../../Component/UI/Text';

export default class StarChestStarsCount extends Element {
    public static TEXT = 'star_chest_count_text';

    public create(params: {
        name: string;
        layout: IElementLayout;
        stars: number;
    }) {
        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                pivot: [0.5, 0.5],
                ...params.layout,
            },
            components: [],
            children: [
                {
                    name: 'star_chest_star',
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [1, 1],
                        pivot: [0.5, 0.5],
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'center_starbg',
                            },
                        },
                    ],
                    children: [
                        {
                            name: StarChestStarsCount.TEXT,
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [0, 0, 0, 0],
                                scale: [1, 1],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        text: String(params.stars),
                                        style:
                                            'star_chest.star_requirement.star',
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        });
    }

    public updateStarsAmount(starCount: number): void {
        const starTextComponent = this.findChildByName(
            StarChestStarsCount.TEXT
        ).getComponent(UITextComponent);
        starTextComponent.text = String(starCount);
    }
}
